import Category from "./category";

const Microexam = {
  Category,
};

export default Microexam;
